export const products = [
  {
    id: 1,
    name: "Metering Dosing Pump",
    brand: "OBL / Flowserve Italia",
    category: "Pumping System",
    desc: "Pompa injeksi kimia presisi tinggi untuk sistem Water Treatment Plant (WTP) dan Boiler Pembangkit Listrik.",
    image: "/images/products/metering_pump_obl.jpg",
    specs: [
      "Akurasi Debit ±1%",
      "Material AISI 316 / PVC",
      "Max Pressure 20 Bar",
    ],
    tag: "High Precision",
  },
  {
    id: 2,
    name: "Progressive Cavity Pump",
    brand: "Netzsch / Seepex Type",
    category: "Pumping System",
    desc: "Solusi pemindahan fluida viskositas tinggi, lumpur industri, dan zat abrasif dengan aliran konstan.",
    image: "/images/products/green_cavity_pump.jpg",
    specs: ["Self-Priming up to 9m", "Low Shear Flow", "Wear Resistant Rotor"],
    tag: "Heavy Viscosity",
  },
  {
    id: 3,
    name: "Industrial Centrifugal Pump",
    brand: "Ebara / Grundfos Pumps",
    category: "MEP Specialist",
    desc: "Sirkulasi kapasitas besar untuk Cooling Tower, Fire Hydrant System, dan distribusi air industri.",
    image: "/images/products/centrifugal_pump_service.jpg",
    specs: [
      "IE3 High Efficiency",
      "Laser Alignment Ready",
      "Cast Iron / SS304",
    ],
    tag: "MEP Ready",
  },
  {
    id: 4,
    name: "Industrial Ball Valve",
    brand: "Arita Indonesia (Official)",
    category: "Flow Control",
    desc: "Kontrol aliran uap (steam) dan cairan kimia tekanan tinggi dengan standar sertifikasi ANSI/JIS.",
    image: "/images/maintenance_berkah.jpg",
    specs: [
      "Class 150/300 / PN16",
      "Fire Safe Design",
      "Full Bore / Reduced Bore",
    ],
    tag: "Official Partner",
  },
  {
    id: 5,
    name: "Mechanical Seal & Gasket",
    brand: "Burgmann / Chesterton",
    category: "Maintenance Support",
    desc: "Komponen penyekat poros pompa industri untuk mencegah kebocoran fluida pada tekanan dan suhu tinggi.",
    image: "/images/pabrikasi_berkah.jpg",
    specs: ["High Temp Resistance", "Chemical Compatibility", "Precision Fit"],
    tag: "Spare Part",
  },
  {
    id: 6,
    name: "Electrical Panel Component",
    brand: "Schneider / ABB Industrial",
    category: "Electrical",
    desc: "Komponen proteksi, breaker (MCCB/ACB), dan kontrol untuk sistem MEP serta otomatisasi industri.",
    image: "/images/mep_berkah.jpg",
    specs: ["Standard SNI/IEC", "High Breaking Capacity", "Modular System"],
    tag: "Electrical Grade",
  },
  {
    id: 7,
    name: "Piping & Spool Fabricated",
    brand: "Seamless Carbon Steel",
    category: "Infrastructure",
    desc: "Pengadaan pipa seamless dan pengerjaan fabrikasi spool sesuai drawing teknis untuk jalur distribusi fluida.",
    image: "/images/pabrikasi_berkah.jpg",
    specs: ["Sch 40/80 / XXS", "NDT Tested Ready", "ISO Standard Welding"],
    tag: "Fabrication",
  },
  {
    id: 8,
    name: "Scaffolding System Set",
    brand: "Berkah Angsana Standard",
    category: "Scaffolding",
    desc: "Penyediaan set scaffolding lengkap dengan sertifikasi kelayakan untuk mendukung inspeksi dan maintenance ketinggian.",
    image: "/images/scaffolding_berkah.jpg",
    specs: ["Steel Galvanized", "K3 Certified", "Modular Easy Install"],
    tag: "Safety Certified",
  },
];

export const productCategories = [
  "SEMUA",
  "Pumping System",
  "Flow Control",
  "MEP Specialist",
  "Maintenance Support",
  "Infrastructure",
  "Electrical",
  "Scaffolding",
];
